import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/reducers';

interface CapitalState {
  isCapitalFinancingEnabled: boolean;
}

const initialState: CapitalState = {
  isCapitalFinancingEnabled: false
};

const capitalSlice = createSlice({
  name: 'capital',
  initialState,
  reducers: {
    setCapitalFinancingEnabled: (state, action: PayloadAction<boolean>) => {
      state.isCapitalFinancingEnabled = action.payload;
    }
  }
});

export const { setCapitalFinancingEnabled } = capitalSlice.actions;

export const selectCapitalFinancingEnabled = (state: RootState) => state.rootReducer.capital.isCapitalFinancingEnabled;

export default capitalSlice.reducer;
